(function (window, document) {
  'use strict';

  function boot() {
    var BB = window.BB;
    if (!BB || !BB.config || window.__bbPostHogInitialized) return;
    window.__bbPostHogInitialized = true;

    var config = BB.config.posthog || {};
    var mode = config.mode;
    var status = 'off';
    var consentActive = false;
    var epoch = 0;
    var queue = [];
    var sdk = null;
    var sdkReady = false;
    var sdkInitialized = false;
    var scriptRequested = false;
    var scriptLoaded = false;
    var failed = false;
    var resetOnResume = false;
    var pageviewSent = false;
    var scrollMilestones = {};
    var scrollPending = false;
    var privacyRequested = false;
    var loadTimer = null;
    var consentAt = 0;
    var productViews = {};
    var cartViews = {};
    var bridgeWrittenAt = 0;
    var BRIDGE_KEY = 'bb_ph_checkout_context_v1';
    var BRIDGE_TTL_MS = 30 * 60 * 1000;
    var PROJECT_ID = '313409';
    var SHOP_DOMAIN = 'qrmrkb-7a.myshopify.com';
    var PRODUCTION_THEME_ID = '201736356223';
    var QUEUE_LIMIT = 50;
    var QUEUE_TTL_MS = 10000;
    var VERSION = '1.1.0';

    BB.posthog = Object.freeze({
      status: function () {
        return {
          version: VERSION,
          mode: mode || 'off',
          state: status,
          consent: consentActive && consentGranted() ? 'granted' : 'denied_or_unknown',
          sdkLoaded: scriptLoaded,
          sdkInitialized: sdkInitialized,
          queuedEvents: queue.length,
          accountVerified: config.accountVerified === true,
          checkoutBridgePrepared: config.checkoutBridgeEnabled === true,
          checkoutBridgeWritten: bridgeWrittenAt > 0
        };
      }
    });

    function has(object, key) { return Object.prototype.hasOwnProperty.call(object, key); }
    function text(value) { return typeof value === 'string' ? value.trim() : ''; }
    function hostAllowed(list) {
      if (!Array.isArray(list)) return false;
      var host = String(window.location.hostname || '').toLowerCase();
      return list.some(function (entry) {
        return typeof entry === 'string' && /^[a-z0-9.-]+$/i.test(entry.trim()) && entry.trim().toLowerCase() === host;
      });
    }
    function secureOrigin(value) {
      try {
        var url = new URL(text(value));
        return url.protocol === 'https:' && !url.username && !url.password &&
          !url.search && !url.hash && (url.pathname === '/' || url.pathname === '') ? url.origin : null;
      } catch (e) { return null; }
    }
    function decoded(value) {
      try { return decodeURIComponent(value); } catch (e) { return value; }
    }
    function sensitiveText(value) {
      var s = decoded(String(value));
      return /[\r\n<>@]/.test(s) || /(?:\+?\d[\d\s().-]{7,})/.test(s) || /(?:token|password|email|authorization)\s*[:=]/i.test(s);
    }
    function safeUrl(value) {
      if (typeof value !== 'string' || !value) return null;
      try {
        var u = new URL(value, window.location.origin);
        if (!/^https?:$/.test(u.protocol) || u.username || u.password || sensitiveText(u.pathname) ||
            /(?:^|\/)(?:account|accounts|checkout|checkouts|orders|order-status|challenge|password)(?:\/|$)/i.test(decoded(u.pathname))) return null;
        return u.origin + u.pathname;
      } catch (e) { return null; }
    }
    function safePath(value) {
      if (typeof value !== 'string' || value.charAt(0) !== '/') return null;
      var url = safeUrl(value);
      return url ? new URL(url).pathname : null;
    }
    function maskReplayAttribute(name, value) {
      if (!consentActive || !consentGranted() || typeof value !== 'string') return '';
      name = String(name).toLowerCase();
      if (/^(?:href|src|action|formaction|poster|cite)$/.test(name)) return safeUrl(value) || '';
      if (name === 'style') {
        var layoutProperties = /^(?:display|visibility|position|top|right|bottom|left|inset|width|height|min-width|min-height|max-width|max-height|margin(?:-(?:top|right|bottom|left))?|padding(?:-(?:top|right|bottom|left))?|box-sizing|overflow(?:-x|-y)?|float|clear|z-index|opacity|border(?:-(?:width|style|color|radius))?|background-color|color|font-size|font-weight|line-height|letter-spacing|text-align|white-space|vertical-align|flex(?:-direction|-wrap|-grow|-shrink|-basis)?|align-items|align-self|align-content|justify-content|gap|row-gap|column-gap|grid-template-columns|grid-template-rows|grid-column|grid-row|order|aspect-ratio|object-fit|object-position|transform|transform-origin)$/;
        return value.split(';').map(function (declaration) {
          var colon = declaration.indexOf(':');
          var property = declaration.slice(0, colon).trim().toLowerCase();
          var content = declaration.slice(colon + 1).trim();
          if (colon < 1 || !layoutProperties.test(property) || content.length > 180 ||
              !/^[a-z0-9\s#(),.%+\-]*$/i.test(content) || /(?:url|attr|var|env)\s*\(/i.test(content)) return '';
          return property + ':' + content;
        }).filter(Boolean).join(';');
      }
      if (name === 'class') return !sensitiveText(value) && /^[a-z0-9_\s:-]{0,400}$/i.test(value) ? value : '';
      if (/^(?:width|height|colspan|rowspan|span|tabindex)$/.test(name)) return /^\d{1,6}$/.test(value) ? value : '';
      if (/^(?:hidden|open|disabled|checked|selected|multiple|readonly|required|autofocus)$/.test(name)) return '';
      if (/^(?:role|type|dir|lang|loading|decoding|aria-hidden|aria-expanded|aria-selected|aria-checked|aria-disabled|aria-current)$/.test(name)) {
        return /^[a-z][a-z0-9_-]{0,35}$/i.test(value) && !sensitiveText(value) ? value : '';
      }
      return '';
    }
    function sensitivePage() {
      var path = decoded(window.location.pathname || '');
      return /(?:^|\/)(?:account|accounts|checkout|checkouts|orders|order-status|challenge|password)(?:\/|$)/i.test(path) || sensitiveText(path);
    }
    function previewPage() {
      try {
        var params = new URLSearchParams(window.location.search);
        return params.has('preview_theme_id') || params.has('preview_key') || params.has('preview_token');
      } catch (e) { return true; }
    }
    function consentGranted() {
      try {
        var navigator = window.navigator || {};
        if (navigator.globalPrivacyControl === true || /^(?:1|yes)$/i.test(String(navigator.doNotTrack || window.doNotTrack || ''))) return false;
        var privacy = window.Shopify && window.Shopify.customerPrivacy;
        if (!privacy || typeof privacy.currentVisitorConsent !== 'function' || typeof privacy.analyticsProcessingAllowed !== 'function') return false;
        var choice = privacy.currentVisitorConsent();
        return Boolean(choice && choice.analytics === 'yes' && privacy.analyticsProcessingAllowed() === true);
      } catch (e) { return false; }
    }

    function clearCheckoutBridge() {
      bridgeWrittenAt = 0;
      try { window.localStorage.removeItem(BRIDGE_KEY); } catch (e) {}
      try { window.localStorage.removeItem('bb_ph_checkout_sent_v1'); } catch (e) {}
      try { window.localStorage.removeItem('bb_ph_checkout_activity_v1'); } catch (e) {}
      try {
        var expired = BRIDGE_KEY + '=; Path=/; Max-Age=0; SameSite=Lax; Secure';
        document.cookie = expired;
        if (/^(?:www\.)?bedsbedding\.nl$/i.test(window.location.hostname)) {
          document.cookie = expired + '; Domain=bedsbedding.nl';
        }
      } catch (e) {}
    }

    function block(reason) { status = reason; clearCheckoutBridge(); }

    function opaqueIdentity(value) {
      return typeof value === 'string' && /^[A-Za-z0-9_-]{8,200}$/.test(value) ? value : null;
    }

    function previousConsentAt(distinctId, sessionId, now) {
      var candidates = [];
      try { candidates.push(window.localStorage.getItem(BRIDGE_KEY)); } catch (e) {}
      try {
        var cookie = document.cookie.split(';').map(function (part) { return part.trim(); }).find(function (part) {
          return part.indexOf(BRIDGE_KEY + '=') === 0;
        });
        if (cookie) candidates.push(decodeURIComponent(cookie.slice(BRIDGE_KEY.length + 1)));
      } catch (e) {}
      var latest = 0;
      candidates.forEach(function (raw) {
        if (typeof raw !== 'string' || raw.length > 4000) return;
        try {
          var old = JSON.parse(raw);
          if (old && old.version === 1 && old.project_id === PROJECT_ID && old.project_token === projectToken &&
              old.shop === SHOP_DOMAIN && old.mode === 'production' && old.theme_id === PRODUCTION_THEME_ID &&
              old.theme_role === 'main' && old.release === (text(config.release) || '1.91-ph2') &&
              /^(?:www\.)?bedsbedding\.nl$/.test(old.site_hostname) && old.consent === true &&
              old.distinct_id === distinctId && old.session_id === sessionId &&
              Number.isSafeInteger(old.updated_at) && Number.isSafeInteger(old.expires_at) && Number.isSafeInteger(old.consent_at) &&
              old.consent_at > 0 && old.consent_at <= old.updated_at && old.consent_at <= now &&
              old.updated_at <= now + 1000 && old.updated_at > now - BRIDGE_TTL_MS &&
              old.expires_at > now && old.expires_at <= old.updated_at + BRIDGE_TTL_MS) latest = Math.max(latest, old.consent_at);
        } catch (e) {}
      });
      return latest;
    }

    function writeCheckoutBridge(force) {
      if (config.checkoutBridgeEnabled !== true || config.accountVerified !== true || mode !== 'production' ||
          themeRole !== 'main' || String(themeId) !== PRODUCTION_THEME_ID ||
          !/^(?:www\.)?bedsbedding\.nl$/i.test(window.location.hostname) ||
          !sdkReady || !sdk || failed || !consentActive || !consentGranted() || sensitivePage() || previewPage()) {
        clearCheckoutBridge(); return;
      }
      var now = Date.now();
      if (!force && bridgeWrittenAt && now - bridgeWrittenAt < 5000) return;
      try {
        var distinctId = typeof sdk.get_distinct_id === 'function' ? opaqueIdentity(sdk.get_distinct_id()) : null;
        var sessionId = typeof sdk.get_session_id === 'function' ? sdk.get_session_id() : null;
        if (!distinctId || typeof sessionId !== 'string' || !/^[0-9a-f]{8}-[0-9a-f]{4}-7[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(sessionId)) {
          clearCheckoutBridge(); return;
        }
        var existingConsentAt = previousConsentAt(distinctId, sessionId, now);
        if (existingConsentAt && existingConsentAt < consentAt) consentAt = existingConsentAt;
        var context = {
          version: 1, project_id: PROJECT_ID, project_token: projectToken, shop: SHOP_DOMAIN,
          mode: 'production', theme_id: PRODUCTION_THEME_ID, theme_role: 'main',
          site_hostname: window.location.hostname.toLowerCase(), release: text(config.release) || '1.91-ph2',
          distinct_id: distinctId, session_id: sessionId, consent: true, consent_at: consentAt,
          updated_at: now, expires_at: now + BRIDGE_TTL_MS
        };
        var serialized = JSON.stringify(context);
        var stored = false;
        try {
          window.localStorage.setItem(BRIDGE_KEY, serialized);
          stored = window.localStorage.getItem(BRIDGE_KEY) === serialized;
        } catch (e) {}
        try {
          document.cookie = BRIDGE_KEY + '=' + encodeURIComponent(serialized) +
            '; Path=/; Domain=bedsbedding.nl; Max-Age=1800; SameSite=Lax; Secure';
          stored = stored || document.cookie.split(';').some(function (part) {
            return part.trim() === BRIDGE_KEY + '=' + encodeURIComponent(serialized);
          });
        } catch (e) {}
        bridgeWrittenAt = stored ? now : 0;
      } catch (e) { clearCheckoutBridge(); }
    }

    if (mode !== 'test' && mode !== 'production') { clearCheckoutBridge(); return; }
    var shopify = window.Shopify || {};
    var themeRole = shopify.theme && shopify.theme.role;
    var themeId = shopify.theme && shopify.theme.id;
    if (config.designMode === true || shopify.designMode === true) { block('editor_blocked'); return; }
    if (window.location.protocol !== 'https:' || sensitivePage()) { block('page_blocked'); return; }
    if (themeRole !== 'main' && themeRole !== 'unpublished') { block('preview_blocked'); return; }
    if (mode === 'production' && (themeRole !== 'main' || shopify.previewMode === true || previewPage())) {
      block('preview_blocked'); return;
    }
    if (!hostAllowed(mode === 'production' ? config.productionHostnames : config.testHostnames)) {
      block('hostname_blocked'); return;
    }
    if (mode === 'production' && String(themeId) !== PRODUCTION_THEME_ID) { block('theme_blocked'); return; }
    if (mode === 'production' && config.accountVerified !== true) { block('account_verification_required'); return; }
    var projectToken = text(mode === 'test' ? config.testProjectToken : config.projectToken);
    if (!/^phc_[A-Za-z0-9_-]{8,}$/.test(projectToken) || (mode === 'test' && projectToken === text(config.projectToken))) {
      block('token_missing_or_invalid'); return;
    }
    var apiHost = secureOrigin(config.apiHost);
    var uiHost = secureOrigin(config.uiHost);
    var sdkHost = secureOrigin(config.sdkHost);
    if (!apiHost || !uiHost || !sdkHost || (mode === 'production' &&
        (apiHost !== 'https://eu.i.posthog.com' || uiHost !== 'https://eu.posthog.com' || sdkHost !== 'https://eu-assets.i.posthog.com'))) {
      block('endpoint_invalid'); return;
    }

    var blockedSelectors = 'bb-booking,[data-bbp-form],.bbp-confirm,form,input,textarea,select,[contenteditable],iframe,bb-search,[data-search-term],[data-search-no-results],a[href^="mailto:"],a[href^="tel:"],.ph-no-capture';
    var extraSelectors = text(config.additionalBlockedSelectors);
    if (extraSelectors) {
      try { document.querySelector(extraSelectors); blockedSelectors += ',' + extraSelectors; }
      catch (e) { status = 'privacy_selector_invalid'; return; }
    }

    var bookingFields = ['source_surface', 'placement', 'presentation', 'environment', 'contract_version',
      'store_slug', 'appointment_type', 'product_id', 'product_classification', 'brand', 'campaign'];
    var allowedEvents = {
      appointment_start: bookingFields,
      appointment_store_selected: bookingFields,
      appointment_date_selected: bookingFields,
      appointment_slot_selected: bookingFields,
      appointment_contact_start: bookingFields,
      appointment_submit: bookingFields,
      appointment_confirmed: bookingFields,
      appointment_error: bookingFields.concat(['error_code']),
      bb_appointment_cta_clicked: ['source_surface', 'placement', 'presentation', 'product_id', 'store_slug'],
      bb_product_interaction: ['interaction', 'placement', 'product_id', 'store_slug', 'media_index', 'item'],
      store_call_click: ['store_slug'],
      store_route_click: ['store_slug'],
      store_selected: ['store_slug', 'via'],
      store_locator_view: ['source_surface', 'product_context'],
      store_locator_search: ['query_type', 'results_count'],
      store_view: ['store_slug'],
      campaign_click: ['campaign_id', 'campaign_level', 'brand', 'target'],
      campaign_view: ['campaign_id', 'campaign_level', 'brand'],
      view_item: ['item_id', 'variant_id', 'item_brand', 'item_category', 'currency', 'product_mode', 'price', 'price_basis'],
      select_item: ['item_id', 'item_list_name'],
      bb_variant_selected: ['item_id', 'variant_id', 'price', 'price_basis', 'currency', 'product_mode'],
      add_to_cart: ['item_id', 'variant_id', 'price', 'price_basis', 'quantity', 'currency'],
      bb_cart_viewed: ['cart_surface', 'cart_view_id', 'item_count', 'value', 'currency'],
      bb_cart_item_removed: ['item_id', 'variant_id', 'quantity', 'price', 'price_basis', 'currency'],
      begin_checkout: ['currency'],
      bb_search_submit: ['search_source', 'search_result_count'],
      bb_search_view: ['search_source', 'search_result_count', 'search_collection_count', 'search_result_type'],
      bb_search_zero_results: ['search_source', 'search_result_type'],
      bb_search_suggestion_click: ['search_source', 'search_result_type'],
      bb_search_result_click: ['search_result_type', 'search_result_position'],
      bb_search_filter_change: ['search_result_type', 'search_result_count']
    };
    var numericFields = ['contract_version', 'media_index', 'price', 'quantity', 'results_count', 'item_count', 'value',
      'search_result_count', 'search_collection_count', 'search_result_position', 'scroll_depth'];
    var integerFields = ['contract_version', 'media_index', 'quantity', 'results_count', 'item_count',
      'search_result_count', 'search_collection_count', 'search_result_position', 'scroll_depth'];
    var idFields = ['product_id', 'item_id', 'variant_id', 'theme_id'];
    var tokenFields = ['source_surface', 'placement', 'presentation', 'environment', 'store_slug', 'appointment_type',
      'product_classification', 'error_code', 'interaction', 'via', 'product_context', 'query_type', 'search_source',
      'search_result_type', 'product_mode', 'campaign_level', 'price_basis', 'cart_surface', 'cart_view_id'];

    function safeField(key, value) {
      if (value === null) return null;
      if (numericFields.indexOf(key) !== -1) {

        return typeof value === 'number' && isFinite(value) && value >= 0 && value <= 1e9 &&
          (integerFields.indexOf(key) === -1 || Math.floor(value) === value) ? value : undefined;
      }
      if (idFields.indexOf(key) !== -1) {
        var id = typeof value === 'number' && isFinite(value) ? String(value) : text(value);
        return /^(?:\d{1,24}|gid:\/\/shopify\/(?:Product|ProductVariant)\/\d{1,24})$/.test(id) ? id : undefined;
      }
      if (typeof value !== 'string') return undefined;
      var s = value.trim();
      if (!s || s.length > 120 || sensitiveText(s)) return undefined;
      if (key === 'currency') return /^[A-Z]{3}$/.test(s) ? s : undefined;
      if (key === 'price_basis') return ['from_price', 'selected_variant'].indexOf(s) !== -1 ? s : undefined;
      if (key === 'cart_surface') return ['drawer', 'page'].indexOf(s) !== -1 ? s : undefined;
      if (tokenFields.indexOf(key) !== -1) return /^[a-z0-9][a-z0-9_.:-]{0,79}$/i.test(s) ? s : undefined;
      if (key === 'target') {
        if (/^(?:https?:\/\/|\/)/i.test(s)) return safeUrl(s) || undefined;
        return /^[a-z0-9][a-z0-9_.:-]{0,79}$/i.test(s) ? s : undefined;
      }
      return /^[\p{L}\p{N} ._&()'/-]{1,120}$/u.test(s) ? s : undefined;
    }

    function baseProperties() {
      var props = {
        bb_tracking_mode: mode,
        bb_adapter_version: VERSION,
        theme_role: themeRole,
        site_hostname: window.location.hostname,
        $process_person_profile: false
      };
      ['page_type', 'template', 'release'].forEach(function (key) {
        var value = key === 'page_type' ? config.pageType : config[key];
        if (typeof value === 'string' && /^[a-z0-9][a-z0-9_.:-]{0,79}$/i.test(value)) props[key] = value;
      });
      var safeThemeId = safeField('theme_id', themeId);
      if (safeThemeId !== undefined) props.theme_id = safeThemeId;
      var url = safeUrl(window.location.href);
      if (url) { props.$current_url = url; props.page_path = new URL(url).pathname; }
      return props;
    }

    function safeEvent(name, input) {
      var fields = allowedEvents[name];
      if (!fields) return null;
      var props = baseProperties();
      fields.forEach(function (key) {
        if (!has(input, key)) return;
        var value = safeField(key, input[key]);
        if (value !== undefined) props[key] = value;
      });
      return { name: name, properties: props, epoch: epoch, createdAt: Date.now() };
    }

    var internalFields = ['token', 'distinct_id', '$device_id', '$session_id', '$window_id', '$lib', '$lib_version',
      '$browser', '$browser_version', '$os', '$os_version', '$device_type', '$screen_height', '$screen_width',
      '$viewport_height', '$viewport_width', '$time', '$event_type', '$pageview_id', '$is_identified',
      '$session_recording_start_reason', '$session_recording_console_log_count', '$session_recording_network_payload_size',
      '$pageview_max_scroll', '$pageview_max_scroll_percentage', '$pageview_last_scroll', '$pageview_last_scroll_percentage',
      '$prev_pageview_max_scroll', '$prev_pageview_max_scroll_percentage', '$prev_pageview_last_scroll',
      '$prev_pageview_last_scroll_percentage', '$prev_pageview_duration', '$prev_pageview_id',
      '$prev_pageview_height', '$prev_pageview_last_content', '$prev_pageview_last_content_percentage', '$prev_pageview_max_content', '$prev_pageview_max_content_percentage',
      '$pageview_height', '$pageview_last_content', '$pageview_max_content', '$pageview_max_content_percentage'];
    var contextFields = ['bb_tracking_mode', 'bb_adapter_version', 'theme_id', 'theme_role', 'site_hostname', 'page_path', 'page_type', 'template', 'release'];
    var vitalFields = ['$web_vitals_LCP_value', '$web_vitals_FCP_value', '$web_vitals_INP_value', '$web_vitals_CLS_value'];
    var urlFields = ['$current_url', '$initial_current_url', '$referrer', '$initial_referrer', '$session_entry_url', '$session_exit_url'];

    function safeHeatmap(input) {
      if (!input || typeof input !== 'object' || Array.isArray(input)) return null;
      var result = {};
      var count = 0;
      Object.keys(input).slice(0, 100).forEach(function (url) {
        var cleanUrl = safeUrl(url);
        if (!cleanUrl || !Array.isArray(input[url])) return;
        input[url].slice(0, 2000).forEach(function (point) {
          if (count >= 2000 || !point || typeof point !== 'object' ||
              typeof point.x !== 'number' || !isFinite(point.x) || Math.abs(point.x) > 1e7 ||
              typeof point.y !== 'number' || !isFinite(point.y) || Math.abs(point.y) > 1e7 ||
              typeof point.target_fixed !== 'boolean' ||
              ['click', 'mousemove', 'rageclick', 'deadclick'].indexOf(point.type) === -1) return;
          if (!has(result, cleanUrl)) result[cleanUrl] = [];
          result[cleanUrl].push({ x: point.x, y: point.y, target_fixed: point.target_fixed, type: point.type });
          count += 1;
        });
      });
      return count ? result : null;
    }

    function beforeSend(event) {
      if (!event || failed || !consentActive || !consentGranted() || sensitivePage()) return null;
      var name = event.event;
      var source = event.properties || {};
      if (name === '$snapshot') {
        if (config.replayEnabled !== true || replayRate <= 0 ||
            (!Array.isArray(source.$snapshot_data) && typeof source.$snapshot_data !== 'string')) return null;
        var snapshot = {
          $snapshot_data: source.$snapshot_data,
          $snapshot_host: window.location.hostname,
          token: projectToken,
          $config_defaults: '2026-05-30'
        };
        ['$session_id', '$window_id', '$lib', '$lib_version', 'distinct_id'].forEach(function (key) {
          if (typeof source[key] === 'string') snapshot[key] = source[key];
        });
        if (typeof source.$snapshot_bytes === 'number' && isFinite(source.$snapshot_bytes) && source.$snapshot_bytes >= 0) {
          snapshot.$snapshot_bytes = source.$snapshot_bytes;
        }
        var snapshotContext = baseProperties();
        contextFields.forEach(function (key) { if (has(snapshotContext, key)) snapshot[key] = snapshotContext[key]; });
        event.properties = snapshot;
        return event;
      }
      var heatmap = name === '$$heatmap' && config.heatmapsEnabled === true ? safeHeatmap(source.$heatmap_data) : null;
      if (name === '$$heatmap' && !heatmap) return null;
      var vitals = name === '$web_vitals';
      if (vitals && config.captureWebVitals !== true) return null;
      if (!has(allowedEvents, name) && name !== '$pageview' && name !== '$pageleave' && name !== 'bb_page_scroll' && name !== '$$heatmap' && !vitals) return null;
      var out = {};
      if (vitals) {
        vitalFields.forEach(function (key) {
          var value = source[key];
          if (typeof value === 'number' && isFinite(value) && value >= 0 && value <= 1e9) out[key] = value;
        });
        if (!Object.keys(out).length) return null;
      }
      internalFields.forEach(function (key) {
        var v = source[key];
        if (typeof v === 'string' || typeof v === 'number' || typeof v === 'boolean') out[key] = v;
      });
      (allowedEvents[name] || (name === 'bb_page_scroll' ? ['scroll_depth'] : [])).forEach(function (key) {
        if (!has(source, key)) return;
        var v = safeField(key, source[key]);
        if (v !== undefined) out[key] = v;
      });
      var base = baseProperties();
      contextFields.forEach(function (key) { if (has(base, key)) out[key] = base[key]; });
      urlFields.forEach(function (key) { var u = safeUrl(source[key]); if (u) out[key] = u; });
      var previousPath = safePath(source.$prev_pageview_pathname);
      if (previousPath) out.$prev_pageview_pathname = previousPath;
      out.$current_url = (vitals && safeUrl(source.$current_url)) || safeUrl(window.location.href);
      if (out.$current_url) out.page_path = new URL(out.$current_url).pathname;
      out.$process_person_profile = false;
      if (heatmap) out.$heatmap_data = heatmap;

      event.properties = out;
      return event;
    }

    function send(entry) {
      if (!sdkReady || !consentActive || !consentGranted() || entry.epoch !== epoch ||
          Date.now() - entry.createdAt > QUEUE_TTL_MS || sensitivePage()) return;
      try { sdk.capture(entry.name, entry.properties); writeCheckoutBridge(true); } catch (e) {  }
    }
    function record(entry) {
      if (!entry || !consentActive || !consentGranted() || failed) return false;
      if (sdkReady) { send(entry); return true; }
      queue = queue.filter(function (item) { return item.epoch === epoch && Date.now() - item.createdAt <= QUEUE_TTL_MS; });
      if (queue.length < QUEUE_LIMIT) { queue.push(entry); return true; }
      return false;
    }
    function recordInteraction(name, input) {
      var entry = safeEvent(name, input);
      if (!entry) return;
      var seen = name === 'view_item' ? productViews : (name === 'bb_cart_viewed' ? cartViews : null);
      var key = name === 'view_item' ? entry.properties.item_id : entry.properties.cart_view_id;
      if (seen && (!key || has(seen, key))) return;
      if (record(entry) && seen) seen[key] = true;
    }
    function captureCurrentContexts() {
      if (config.captureInteractions === false || !consentActive || !consentGranted() || failed) return;
      try {
        if (typeof BB.getProductAnalyticsContext === 'function') {
          var product = BB.getProductAnalyticsContext();
          if (product) recordInteraction('view_item', product);
        }
        if (typeof BB.getCartAnalyticsContext === 'function') {
          var cart = BB.getCartAnalyticsContext();
          if (cart) recordInteraction('bb_cart_viewed', cart);
        }
      } catch (e) {}
    }
    function flush() {
      var pending = queue;
      queue = [];
      pending.forEach(send);
    }

    var replayRate = Number(config.replaySampleRate);
    if (!isFinite(replayRate) || replayRate < 0 || replayRate > 1) replayRate = 0;
    function activateSDK() {
      if (!sdkReady || !consentActive || !consentGranted() || failed) return;
      try {
        if (resetOnResume && typeof sdk.reset === 'function') { sdk.reset(); resetOnResume = false; }
        sdk.set_config({ disable_persistence: false, advanced_disable_flags: false,
          disable_external_dependency_loading: false, capture_heatmaps: config.heatmapsEnabled === true });
        sdk.opt_in_capturing({ captureEventName: false });
        status = 'active';
        if (config.capturePageviews !== false && !pageviewSent) {
          pageviewSent = true;
          var props = baseProperties();
          var referrer = safeUrl(document.referrer);
          if (referrer) props.$referrer = referrer;
          send({ name: '$pageview', properties: props, epoch: epoch, createdAt: Date.now() });
        }
        if (config.replayEnabled === true && replayRate > 0) sdk.startSessionRecording();
        flush();
        captureCurrentContexts();
        writeCheckoutBridge(true);
      } catch (e) { status = 'sdk_error'; queue = []; failed = true; stopSDK(); }
    }
    function stopSDK() {
      queue = [];
      clearCheckoutBridge();
      if (!sdkReady || !sdk) return;

      try { sdk.stopSessionRecording(); } catch (e) {}
      try { sdk.opt_out_capturing(); } catch (e) {}
      try { sdk.set_config({ disable_persistence: true, disable_session_recording: true,
        capture_heatmaps: false, advanced_disable_flags: true, disable_external_dependency_loading: true }); } catch (e) {}
      resetOnResume = true;
    }

    function sdkOptions() {
      return {
        api_host: apiHost,
        ui_host: uiHost,
        asset_host: sdkHost,
        defaults: '2026-05-30',
        opt_out_capturing_by_default: true,
        opt_out_persistence_by_default: true,
        persistence: 'localStorage+cookie',
        cross_subdomain_cookie: false,
        secure_cookie: true,
        person_profiles: 'never',
        save_referrer: false,
        save_campaign_params: false,
        disable_capture_url_hashes: true,
        mask_personal_data_properties: true,
        custom_personal_data_properties: ['email', 'name', 'phone', 'token', 'auth', 'q', 'query', 'search', 'note'],
        autocapture: false,
        capture_pageview: false,
        capture_pageleave: config.capturePageviews !== false && config.captureScroll === true,
        disable_scroll_properties: config.captureScroll !== true,
        capture_dead_clicks: false,
        rageclick: false,
        capture_exceptions: false,
        capture_performance: config.captureWebVitals === true ? {
          web_vitals: true, network_timing: false, web_vitals_allowed_metrics: ['LCP', 'CLS', 'FCP', 'INP']
        } : false,
        capture_heatmaps: config.heatmapsEnabled === true,
        disable_session_recording: true,
        enable_recording_console_log: false,
        disable_surveys: true,
        disable_product_tours: true,
        disable_conversations: true,
        disable_web_experiments: true,
        opt_in_site_apps: false,
        advanced_disable_feature_flags: true,
        advanced_disable_flags: false,
        remote_config_refresh_interval_ms: 0,
        tracing_headers: [],
        disableDeviceModel: true,
        internal_or_test_user_hostname: null,
        request_batching: false,
        debug: false,
        mask_all_text: true,
        mask_all_element_attributes: true,
        property_denylist: ['email', 'name', 'phone', 'note', 'search_term', 'search_result_title', '$title',
          'gclid', 'dclid', 'fbclid', 'msclkid', 'publicReference', 'idempotencyKey', '$set', '$set_once'],
        get_current_url: function (url) { return safeUrl(url) || window.location.origin + '/'; },
        before_send: beforeSend,
        prepare_external_dependency_script: function (script) { return consentActive && consentGranted() ? script : null; },
        session_recording: {
          sampleRate: replayRate,
          maskAllInputs: true,
          maskTextSelector: config.maskAllText !== false ? '*' : blockedSelectors,
          maskAttributeFn: maskReplayAttribute,
          blockSelector: blockedSelectors,
          recordCrossOriginIframes: false,
          captureCanvas: { recordCanvas: false },
          recordBody: false,
          recordHeaders: false,
          streamNetworkBody: false,
          captureJsonLd: false,
          maskCapturedNetworkRequestFn: function (request) {
            if (!consentActive || !consentGranted()) return null;
            if (!request || typeof request.name !== 'string') return null;
            var cleaned = safeUrl(request.name);
            if (!cleaned) return null;
            return Object.assign({}, request, { name: cleaned, requestBody: undefined, responseBody: undefined,
              requestHeaders: undefined, responseHeaders: undefined });
          }
        },
        loaded: function (instance) {
          sdk = instance;
          sdkReady = true;
          if (!consentActive || !consentGranted()) { stopSDK(); return; }
          activateSDK();
        }
      };
    }

    function initializeSDK() {
      if (sdkInitialized || !scriptLoaded || !consentActive || !consentGranted() || failed) return;
      var instance = window.posthog;
      if (!instance || typeof instance.init !== 'function') { failed = true; queue = []; status = 'sdk_unavailable'; return; }
      if (instance.config && instance.config.token) { failed = true; queue = []; status = 'existing_sdk_conflict'; return; }
      sdkInitialized = true;
      sdk = instance;
      status = 'initializing';
      try { instance.init(projectToken, sdkOptions()); }
      catch (e) { failed = true; queue = []; status = 'sdk_error'; stopSDK(); }
    }
    function ensureSDK() {
      if (failed || !consentActive || !consentGranted()) return;
      if (sdkReady) { activateSDK(); return; }
      if (scriptLoaded) { initializeSDK(); return; }
      if (scriptRequested) return;
      if (window.posthog || document.querySelector('script[data-bb-posthog-sdk]')) {
        status = 'existing_sdk_conflict'; failed = true; queue = []; return;
      }
      scriptRequested = true;
      status = 'loading';
      var script = document.createElement('script');
      script.async = true;
      script.crossOrigin = 'anonymous';
      script.referrerPolicy = 'no-referrer';
      script.src = sdkHost + '/static/array.js';
      script.setAttribute('data-bb-posthog-sdk', VERSION);
      loadTimer = window.setTimeout(function () { failed = true; queue = []; status = 'sdk_timeout'; }, QUEUE_TTL_MS);
      script.onload = function () {
        window.clearTimeout(loadTimer);
        scriptLoaded = true;

        initializeSDK();
      };
      script.onerror = function () {
        window.clearTimeout(loadTimer);
        failed = true; queue = []; status = 'sdk_load_failed';
      };
      document.head.appendChild(script);
    }

    function syncConsent() {
      var permitted = consentGranted() && !sensitivePage();
      if (!permitted) {
        clearCheckoutBridge();
        if (consentActive) {
          consentActive = false;
          consentAt = 0;
          epoch += 1;
          pageviewSent = false;
          scrollMilestones = {};
          productViews = {};
          cartViews = {};
          stopSDK();
        }
        if (!failed) status = 'consent_required';
        return false;
      }
      if (!consentActive) {
        consentActive = true;
        consentAt = Date.now();
        epoch += 1;
        queue = [];
        ensureSDK();
      }
      return true;
    }

    function observeDataLayer() {
      window.dataLayer = window.dataLayer || [];
      var layer = window.dataLayer;
      if (!Array.isArray(layer) || typeof layer.push !== 'function') return false;
      var previousPush = layer.push;
      function push() {
        var consentAtPush = consentGranted() && !sensitivePage();
        var result = previousPush.apply(this, arguments);
        if (this !== layer) return result;
        try {
          if (config.captureInteractions !== false && syncConsent() && consentAtPush) {
            for (var i = 0; i < arguments.length; i += 1) {
              var item = arguments[i];
              if (item && typeof item === 'object' && !Array.isArray(item) &&
                  typeof item.event === 'string' && has(allowedEvents, item.event)) recordInteraction(item.event, item);
            }
          }
        } catch (e) {  }
        return result;
      }
      try { layer.push = push; } catch (e) { return false; }
      return layer.push === push;
    }

    if (!observeDataLayer()) { status = 'datalayer_unavailable'; return; }
    document.addEventListener('visitorConsentCollected', syncConsent);
    window.addEventListener('pageshow', syncConsent);
    window.addEventListener('focus', syncConsent);
    window.addEventListener('storage', syncConsent);
    document.addEventListener('visibilitychange', function () { if (!document.hidden) syncConsent(); });
    document.addEventListener('bb:analytics-context-ready', function () { if (syncConsent()) captureCurrentContexts(); });
    document.addEventListener('pointerdown', function (event) {
      if (event.isTrusted && syncConsent()) writeCheckoutBridge(false);
    }, { capture: true, passive: true });
    document.addEventListener('click', function (event) {
      if (event.isTrusted && syncConsent()) writeCheckoutBridge(true);
    }, { capture: true, passive: true });
    document.addEventListener('submit', function () { if (syncConsent()) writeCheckoutBridge(true); }, { capture: true });

    if (config.captureScroll === true) {
      window.addEventListener('scroll', function () {
        if (scrollPending || !syncConsent()) return;
        scrollPending = true;
        var observedEpoch = epoch;
        window.requestAnimationFrame(function () {
          scrollPending = false;
          if (!consentActive || !consentGranted() || observedEpoch !== epoch) return;
          var root = document.documentElement;
          var height = Math.max(root.scrollHeight || 0, window.innerHeight || 0);
          var depth = height > 0 ? Math.min(100, Math.round(((window.scrollY || root.scrollTop || 0) + window.innerHeight) / height * 100)) : 0;
          [25, 50, 75, 90].forEach(function (mark) {
            if (depth < mark || scrollMilestones[mark]) return;
            scrollMilestones[mark] = true;
            var props = baseProperties();
            props.scroll_depth = mark;
            record({ name: 'bb_page_scroll', properties: props, epoch: epoch, createdAt: Date.now() });
          });
        });
      }, { passive: true });
    }

    function ensurePrivacy() {
      var platform = window.Shopify;
      if (platform && platform.customerPrivacy) { syncConsent(); return; }
      if (!privacyRequested && platform && typeof platform.loadFeatures === 'function') {
        privacyRequested = true;
        try { platform.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], function () { syncConsent(); }); }
        catch (e) {  }
      }
      syncConsent();
    }
    ensurePrivacy();
    [100, 500, 1500, 5000, 10000].forEach(function (delay) {
      window.setTimeout(function () { if (!failed && !consentActive) ensurePrivacy(); }, delay);
    });
  }

  if (window.BB && window.BB.config) boot();
  else document.addEventListener('bb:ready', boot, { once: true });
})(window, document);
